@if (isLoginRoute) {
  <router-outlet></router-outlet>
} @else {
  <app-navigation>
    <router-outlet></router-outlet>
  </app-navigation>
}
<app-global-loader></app-global-loader>
<app-notification></app-notification>
